import { useMetaMask } from 'metamask-react'
import { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Web3 from 'web3'
import * as Web3Token from 'web3-token'

import s from './LoginModal.module.scss'


import { LoginButton } from './LoginButton/LoginButton'

import { useAuthContext } from 'contexts/AppAuthContext'
import { useArcanaContext } from 'contexts/ArcanaAuthContext'


import { ArrowDownIcon } from 'assets/icons/ArrowDownIcon'
import { DiscordIcon } from 'assets/icons/socials/DiscordIcon'
import { GithubIcon } from 'assets/icons/socials/GithubIcon'
import { GoogleIcon } from 'assets/icons/socials/GoogleIcon'
import { MailIcon } from 'assets/icons/socials/MailIcon'
import { TwitchIcon } from 'assets/icons/socials/TwitchIcon'
import { TwitterIcon } from 'assets/icons/socials/TwitterIcon'
import arcanaLogo from 'assets/svg/arcana-logo-big.png'
import metamaskLoginIcon from 'assets/svg/icons-matamask-white.svg'
import metamaskLogo from 'assets/svg/meta-mask-big.svg'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'
import MetamaskIsDisabledModal from '../MetamaskIsDisabledModal/MetamaskIsDisabledModal'

const LoginModal = memo(() => {
  const navigate = useNavigate()

  const { setArcanaAcc, setWeb3Token, setMetamaskAcc } = useAuthContext()

  // metamaskConnection ====================================================================
  const { status, ethereum, connect } = useMetaMask()
  const [metamaskIsNotAvailable, setMetamaskIsNotAvailable] = useState(false)

  const onCloseModal = () => {
    navigate('../', { replace: true })
  }

  const connectToMetamask = async () => {
    if (status === 'unavailable') {
      setMetamaskIsNotAvailable(true)
    } else {
      await connect()
      const web3 = new Web3(ethereum)
      await ethereum.enable()
      const address = (await web3.eth.getAccounts())[0]
      const token = await Web3Token.sign((msg: string) => web3.eth.personal.sign(msg, address, ''), {
        expires_in: '24h',
      })
      localStorage.setItem('web3token', token)
      setWeb3Token(token)
      localStorage.setItem('metamaskAcc', address)
      setMetamaskAcc(address)
      navigate('../publisher/my-adspaces', { replace: true })
    }
  }

  // const [loading, setLoading] = useState(true)
  const [email, setEmail] = useState('')

  const {
    initializeAuth,
    loggedIn,
    getAccounts,
    loginWithLink,
    initialized,
    auth,
    login,
    loading: arcanaLoading,
  } = useArcanaContext()

  useEffect(() => {
    const initialize = async () => {
      await initializeAuth()
    }
    initialize()
  }, [])

  useEffect(() => {
    const loadDetails = async () => {
      if (initialized) {
        if (loggedIn) {
          const arcanaProvider = await auth.connect()
          //@ts-ignore
          const web3 = new Web3(arcanaProvider)
          const accs = await getAccounts()
          const acc = (accs as string[])[0]
          const token = await Web3Token.sign((msg: string) => web3.eth.personal.sign(msg, acc, ''), {
            expires_in: '24h',
          })
          localStorage.setItem('web3token', token)
          setWeb3Token(token)
          localStorage.setItem('arcanaAcc', acc)
          setArcanaAcc(acc)
          // setLoading(false)
          navigate('../publisher/my-adspaces', { replace: true })
        } else {
          // setLoading(false)
        }
      }
    }
    loadDetails()
  }, [initialized, loggedIn])

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  return (
    <ModalFullScreen onHide={onCloseModal} loading={arcanaLoading} className={s.modalWrapper}>
      <ModalFullScreen.Title>Connect Your Wallet</ModalFullScreen.Title>
      <p className={s.text}>You need to connect Web3 wallet to dive in Meta Ads.</p>
      <div className={s.loginsWrapper}>
        <div className={`${s.metamaskCol} ${s.wrap280}`}>
          <img className={s.logo} src={metamaskLogo} alt="" />
          <div>
            <LoginButton
              onClick={connectToMetamask}
              icon={<img src={metamaskLoginIcon} alt="metamask" />}
              title="Sign in with Metamask"
              iconWrapperColor="#f5841f"
            />
          </div>
        </div>
        <div className={s.arcanaCol}>
          <div className={`${s.wrap280} ${s.arcanaLogoWrapper}`}>
            <img className={s.logo} src={arcanaLogo} alt="" />
          </div>
          <div className={s.loginViaEmail}>
            <div className={`${s.wrap280} ${s.inputAndIconWrapper}`}>
              <div className={s.emailIconWrapper}>
                <MailIcon className={s.emailIcon} />
              </div>
              <input
                type="text"
                placeholder="Enter your email…"
                className={s.emailInput}
                onChange={handleEmailChange}
                value={email}
              />
              {!!email?.length && (
              <CustomButton variant="primary" onClick={() => loginWithLink(email)} className={s.emailLoginBtn}>
                <ArrowDownIcon className={s.rotatedArrow} />
              </CustomButton>
            )}
            </div>
            
          </div>
          <div className={`${s.wrap280} ${s.splitterWrapper}`}>
            <div className={s.splitter} />
          </div>
          <div className={`${s.OAuthSocWrapper} ${s.wrap280}`}>
            <LoginButton
              onClick={() => login('google')}
              icon={<GoogleIcon className={s.socIcon} />}
              title="Sign in with Google"
              iconWrapperColor="#ea4236"
            />
            <LoginButton
              onClick={() => login('twitter')}
              icon={<TwitterIcon className={s.socIcon} />}
              title="Sign in with Twitter"
              iconWrapperColor="#00acee"
            />
            <LoginButton
              onClick={() => login('discord')}
              icon={<DiscordIcon className={s.socIcon} />}
              title="Sign in with Discord"
              iconWrapperColor="#7289da"
            />
            <LoginButton
              onClick={() => login('twitch')}
              icon={<TwitchIcon className={s.socIcon} />}
              title="Sign in with Twitch"
              iconWrapperColor="#6441a5"
            />
            <LoginButton
              onClick={() => login('github')}
              icon={<GithubIcon className={s.socIcon} />}
              title="Sign in with Github"
              iconWrapperColor="#171515"
            />
          </div>
        </div>
      </div>
      {metamaskIsNotAvailable && <MetamaskIsDisabledModal onHide={() => setMetamaskIsNotAvailable(false)} />}
    </ModalFullScreen>
  )
})

export default LoginModal
